module.exports = __webpack_public_path__ + "static/media/vf-button-top.ccd2c772.svg";